import * as React from 'react';
import { HookPaginationProps } from 'modules/common/hook/usePaginationHook';
import SchemaForm from 'modules/common/SchemaForm';
import { schemaFilterTherapyForm } from './schema';
import { setOrderTherapy } from '../../../../common/redux/commonReducer';
import useGeneralHook from '../../../../common/hook/useGeneralHook';
import { intersection } from 'lodash';
import { ROLES } from 'modules/common/constants';
import { useSelector } from 'react-redux';
import { AppState } from 'redux/reducer';

interface Props {
  pagin?: React.ReactNode;
  onRegister?: () => void;
  onExportHandle: () => void;
  hookPagination: HookPaginationProps;
  onDataLoading: boolean;
}

const FilterTherapyBox: React.FunctionComponent<Props> = (props) => {
  const { hookPagination, pagin, onDataLoading, onRegister, onExportHandle } = props;
  const { params, setParams, clearParams } = hookPagination;
  const { dispatch } = useGeneralHook();
  const roles = useSelector((state: AppState) => state.authen.user?.role);

  const hideExport = React.useMemo(() => {
    return intersection([ROLES.ADMIN.value], roles).length > 0;
  }, [roles]);

  return (
    <SchemaForm
      schema={schemaFilterTherapyForm}
      onSubmit={(value) => {
        dispatch(setOrderTherapy(value.orderBy));
        setParams(value);
      }}
      formData={params}
      clearParams={clearParams}
      hideSubmitButton
      pagin={pagin}
      onRegister={onRegister}
      onDataLoading={onDataLoading}
      onExportHandle={onExportHandle}
      hideExport={hideExport}
    />
  );
};

export default FilterTherapyBox;
